export default {"src":"/_next/static/media/Partite.fdedf0b2.svg","height":32,"width":48};